<div fxLayout="row" fxLayoutAlign="start center">
    <h1 class="mat-title">The borrower wasn't found in our system</h1>
</div>

<div fxLayout="row" fxLayoutAlign="start center">
    <button mat-raised-button (click)="goBack()">Go back</button>
</div>
